import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './password-group.types';
import * as constants from './password-group.constants';

export const passwordGroupReducer = generateResourceReducer<types.IPasswordGroup>({
  STORE: constants.STORE_PASSWORD_GROUP,
  CLEAR: constants.CLEAR_PASSWORD_GROUP,
});
